module.exports = __webpack_public_path__ + "img/12-delete.8047926d.svg";